import { render, staticRenderFns } from "./BrowseGoalsPage.vue?vue&type=template&id=415c40ab&scoped=true"
import script from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsPage.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsPage.vue?vue&type=style&index=0&id=415c40ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c40ab",
  null
  
)

export default component.exports